type IguanaStreamWithSave = { savePromise?: Promise<unknown> };
type StreamClass = { getCached: (streamId: string) => IguanaStreamWithSave };

/*
    Waits for a progress save that the lesson player started and has not finished.

    The save lives on the Iguana stream, as lesson_streams_progress.$$savePromise, which `savePromise`
    on the stream surfaces. There is no vanilla equivalent: the player is still Angular and it owns the
    save.

    getCached throws when the stream is not in the Angular cache, which is the case for a student who
    opens a page directly rather than arriving from the player. Nothing is saving then, so the throw
    means "carry on".
*/
export async function waitForPendingStreamSave($injector: angular.auto.IInjectorService, streamId: string) {
    try {
        await $injector.get<StreamClass>('Lesson.Stream').getCached(streamId).savePromise;
    } catch {
        // nothing cached, so nothing to wait for
    }
}
